import type { FC } from 'react';
import classNames from 'classnames';

import { CS_VIDEOGAME_TITLES } from 'app/config/videogameSpecific.config';

import style from './style.module.scss';

interface Props extends ClassNameProp {
  name: string;
  size?: 'normal' | 'small';
  returnEmpty?: boolean;
}

const CS_VIDEOGAME_TITLES_TAGS: Record<CounterStrikeVersion, string> = {
  'cs-2': 'CS2',
  'cs-go': 'CS:GO'
};

const VideogameVersionTag: FC<Props> = ({
  name,
  size = 'normal',
  className,
  returnEmpty = false
}) => {
  const videogameTitle = CS_VIDEOGAME_TITLES[name];

  if (videogameTitle) {
    return (
      <div
        className={classNames(
          style.videogameVersionTag,
          { [style.small]: size === 'small' },
          className
        )}
      >
        {CS_VIDEOGAME_TITLES_TAGS[videogameTitle]}
      </div>
    );
  }

  if (returnEmpty) {
    return <div />;
  }

  return null;
};

VideogameVersionTag.displayName = 'VideogameVersionTag';

export default VideogameVersionTag;
